
import { locale } from './globals.js';

class Accordion {
  constructor(el) {
    this.el = el;
    this.oneOnly = this.el.hasAttribute('data-show-one');
    this.showFirst = this.el.hasAttribute('data-show-first');
    this.initSections();
  }
  initSections () {
    this.sections = [];
    Array.from(this.el.querySelectorAll('[data-accordion-header]')).forEach((header, i) => {
      var index = i;
      var content = header.nextElementSibling;
      header.classList.add('accordion-header');
      content.classList.add('accordion-content');

      this.sections[index] = {
        header, content
      }
      header.setAttribute('data-index', index);
      header.addEventListener('click', (event) => {
        this.activate(index);
      })
      if(index === 0 && this.showFirst) {
        header.classList.add('active');
      } else {
        $(content).slideUp();
      }
    });
  }
  activate (index) {
    this.sections.forEach((section, i) => {
      if(i == index) {
        if(section.header.classList.contains('active')) {
          section.header.classList.remove('active')
          $(section.content).slideUp();
        } else {
          section.header.classList.add('active');
          $(section.content).slideDown();
        }
      } else if(this.oneOnly) {
        section.header.classList.remove('active')
        $(section.content).slideUp();
      }
    })
  }
};


export default function () {
	Array.from(document.querySelectorAll('[data-accordion]')).forEach(function(item){
		new Accordion(item);
	})
}
